window.$_CONFIG = window.$_CONFIG || {};